import angular from 'angular';
import SendGamePlanToEsign from './sendGamePlanToEsign';

export default angular
  .module('components.sendGamePlanToEsign', [])
  .component('sendGamePlanToEsign', SendGamePlanToEsign).name;
